import { render, staticRenderFns } from "./IeMessage.vue?vue&type=template&id=67b63d3b&scoped=true&"
var script = {}
import style0 from "./IeMessage.vue?vue&type=style&index=0&id=67b63d3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b63d3b",
  null
  
)

export default component.exports